import { create } from 'zustand';

const KEY = 'sidebarCollapsed';

interface UiState {
  sidebarCollapsed: boolean;
  toggleSidebar: () => void;
  mobileNavOpen: boolean;
  setMobileNav: (open: boolean) => void;
}

export const useUiStore = create<UiState>((set) => ({
  sidebarCollapsed:
    typeof window !== 'undefined' && window.localStorage.getItem(KEY) === '1',
  toggleSidebar: () =>
    set((s) => {
      const next = !s.sidebarCollapsed;
      window.localStorage.setItem(KEY, next ? '1' : '0');
      return { sidebarCollapsed: next };
    }),
  mobileNavOpen: false,
  setMobileNav: (open) => set({ mobileNavOpen: open }),
}));
